import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { generateUUID } from "@roc/feature-utils";
import { makeObservable } from "mobx";


const initialForm = {
  fields: {
    propertyType: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    },
    numberOfProperties: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    },
    estimatedAsIsValue: {
      value: '',
      error: null,
      rule: 'required',
      message: '',
    }
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    error: null,
  },
};


export class RentalPropertyTypeFormStore extends FormStore {

  public key = generateUUID();

  constructor(globalStore) {
    super(initialForm, globalStore);

    makeObservable(this, {
    });
  }

  reset() {
    super.reset();
  }

  getProperty() {
    const property = this.getFormValues();
    return {
      ...property,
      uuid: this.key,
    };
  }
}